module.exports = __webpack_public_path__ + "img/product.639430a5.png";